module.exports = __webpack_public_path__ + "static/media/Menu_Bar.a6455f4e.svg";